import { SourcesButton } from 'ai-components-ui-library/components/buttons/SourcesButton';
import { Button } from 'foundations-components/transitional/components/Button';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const CitationPopoverFooter = ({
  citation,
  onDetailsClick,
  onSourcesClick
}) => {
  const {
    citations
  } = citation;
  const numberOfSources = citations.length;
  const handleOnDetailsClick = event => {
    event.stopPropagation();
    onDetailsClick();
  };
  const handleOnSourcesClick = event => {
    event.stopPropagation();
    onSourcesClick();
  };
  return /*#__PURE__*/_jsxs(TFlex, {
    alignItems: "center",
    justifyContent: "space-between",
    children: [/*#__PURE__*/_jsx(SourcesButton, {
      count: numberOfSources,
      onClick: handleOnSourcesClick
    }), /*#__PURE__*/_jsx(Button, {
      onClick: handleOnDetailsClick,
      use: "link",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "smartPropertyCitationPopover.viewAllDetailsLink"
      })
    })]
  });
};